import PropTypes from 'prop-types'
import classNames from 'classnames'
import { get } from 'lodash'

import RawHTML from '../../../common/raw-html'
import { KIND_DOCUMENT, KIND_EBOOK } from '../constants'

const Player = ({ resource, ...attrs }) => {
  const hasEmbedCode = !!resource.embedCode
  const isDocument = [KIND_DOCUMENT, KIND_EBOOK].includes(resource.kind)
  const hasFile = !!get(resource, 'document.meta.downloadUrl', null)

  let match = null
  let padding = '141.428571%'

  if (hasEmbedCode) {
    match = resource.embedCode.match(/height="(\d+)(.*)"/)
    if (match) {
      const value = match[1]
      const unit = match[2]
      if (unit === 'px' || unit === '') {
        padding = `${value}px`
      }
    }
  }

  attrs.className = classNames(
    attrs.className,
    [
      'h-0',
      'w-full',
      'relative',
      'bg-black-01',
      'iframe-wrapper'
    ]
  )

  attrs.style = {
    ...attrs.style ? attrs.style : {},
    paddingTop: padding
  }

  return <>
    {
      isDocument
        ? hasEmbedCode
          ? <div
            {...attrs
            } >
            <RawHTML html={resource.embedCode} />
          </div >
          : hasFile
            ? null
            : null
        : null
    }
  </>
}

Player.propTypes = {
  resource: PropTypes.object.isRequired
}

export default Player
